import React from 'react';
import Button from '../components/Button';
import classnames from 'classnames';

import { makeBtStyles } from '../Theme';
import { useReturnState } from '../ReturnsPageApp';
import CarrierIcon from '../components/CarrierIcon';

import { ReactComponent as Step1Icon } from './InstructionsStep1.svg';
import { ReactComponent as Step2Icon } from './InstructionsStep2.svg';


const useStyles = makeBtStyles( theme => ({
  root: {
    width: '780px'
  },
  heading: {
    ...theme.characteristicFont,
    fontSize: '21px'
  },
  stepsTable: {
    border: '1px solid #DEDEDE',
    listStyleType: 'none',
    padding: '0'
  },
  button: {
    fontSize: '16px'
  },
  instructionText: {
    margin: '0',
    marginBottom: '15px',
    fontSize: '14px',
    lineHeight: '20px'
  }
}));


export default function ReturnConfirmation({ className='' }) {
  const classes = useStyles();
  const { label } = useReturnState();

  return <div className={classnames(classes.root,className)}>
    <h2 className={classes.heading}>Return Confirmation No. 1234</h2>

    <ol className={classes.stepsTable}>
      <Step className={classes.step} label="1. Print Return Shipping Label" icon={<Step1Icon />}>
        <p className={classes.instructionText}>
          Your shipping label is ready to print.
        </p>
        <Button variant="primary" as="a" href={label.download} target="_blank" rel="noopener noreferrer">
          Print Return Label
        </Button>
      </Step>
      <Step className={classes.step} label="2. Package Return Items" icon={<Step2Icon />}>
        Place all items in the original package (or similar packaging) and seal it securely. Then attach the return label to the outside of the package.
      </Step>
      <Step className={classes.step} label="3. Drop Off Package" icon={<CarrierIcon carrier_code={label.carrier_code} />}>
        Take the package to the nearest USPS location to be shipped.
      </Step>
    </ol>
  </div>;
}


const useStepStyles = makeBtStyles( theme => ({
  step: {
    padding: '20px',
    display: 'flex',
    '& + &': {
      borderTop: '1px solid #DEDEDE'
    }
  },
  iconWrapper: {
    padding: '0 25px 0 5px',
    '& > *': {
      width: '60px'
    }
  },
  label: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '25px',
    display: 'block',
    marginBottom: '4px'
  }
}));

const Step = (
  { className, label, icon, children } :
  { className:string, label:string, icon:React.ReactNode, children: React.ReactNode | React.ReactNodeArray }
) => {
  const classes = useStepStyles();

  return <li className={classes.step}>
    <div className={classes.iconWrapper}>
      {icon}
    </div>
    <div>
      <label className={classes.label}>{label}</label>
      {children}
    </div>
  </li>;
};